import {createFeature, createReducer, on} from '@ngrx/store';
import {ConnectState} from '../../../shared/constants/connect-state';
import {AdAccountsActions} from './ad-accounts.actions';
import {AdAccount} from '../../../shared/api/models/ad-accounts';

export interface PlatformAdAccountState {
	loading: boolean;
	error: any;
	connectState: ConnectState;
	adAccounts: AdAccount[];
	pickedAdAccounts: AdAccount[];
}

export const initialState: PlatformAdAccountState = {
	loading: false,
	error: null,
	connectState: ConnectState.Pending,
	adAccounts: [],
	pickedAdAccounts: [],
};

export const adAccountsFeature = createFeature({
	name: 'AdAccounts',
	reducer: createReducer(
		initialState,
		on(AdAccountsActions.loadAdAccounts, (state) => ({
			...state,
			loading: true,
		})),
		on(AdAccountsActions.loadAdAccountsSuccess, (state, payload) => ({
			...state,
			loading: false,
			adAccounts: payload.data,
			connectState: ConnectState.Success,
		})),
		on(AdAccountsActions.loadAdAccountsFailure, (state) => ({
			...state,
			loading: false,
			connectState: ConnectState.Error,
		})),
		on(AdAccountsActions.searchAdAccounts, (state) => ({
			...state,
			loading: false,
			connectState: ConnectState.Error,
		})),
		on(AdAccountsActions.pickAdAccount, (state, payload) => ({
			...state,
			pickedAdAccounts: [...state.pickedAdAccounts, payload.data]
		})),
		on(AdAccountsActions.removeAdAccount, (state, payload) => ({
			...state,
			pickedAdAccounts: [...state.pickedAdAccounts.filter((adAccount) => adAccount.id !== payload.data.id)]
		})),
		on(AdAccountsActions.pickAdAccounts, (state, payload) => ({
			...state,
			pickedAdAccounts: payload.data,
		})),
	)
});
